import { QuestionCircleOutlined } from '@ant-design/icons'
import { useRequest } from 'ahooks'
import { Popconfirm } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ResourceType } from '@/schemas'

interface RelationsDeleterProps {
  selfId: string | number
  type: ResourceType
  parentSelfId: string | number
  parentType: ResourceType
  onSuccess: () => void
  isSummaryPage?: boolean
}

export const RelationsDeleter: React.FC<RelationsDeleterProps> = ({
  selfId,
  type,
  parentSelfId,
  parentType,
  onSuccess,
  isSummaryPage = false,
  children,
}) => {
  const { t } = useTranslation()
  const { run } = useRequest(
    {
      url: '/api/relations/deletePpRelations',
      method: 'delete',
      params: {
        selfId,
        type,
        parentSelfId,
        parentType,
        isSummaryPagePermission: isSummaryPage,
      },
    },
    {
      manual: true,
      onSuccess,
    }
  )
  return (
    <Popconfirm
      title={t('remove confirm')}
      okText={t('remove')}
      okButtonProps={{ danger: true }}
      icon={<QuestionCircleOutlined style={{ color: '#e11d48' }} />}
      onConfirm={run}
    >
      {children}
    </Popconfirm>
  )
}
